import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerBillingPage from "../pages/DsokCustomerBillingPage";

export const dsokCustomerBillingRoute = {
  path: "/dsok/customer-detail/:customerUrl/billing",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerBillingPage} />
    </DsokCustomerDetailProvider>
  ),
};
